import { chosenSites } from "app/common/services/chosenSites";
import { CHART_COLORS } from "app/constants/ChartColors";
import { formatShare } from "app/filters/ngFilters";

import { DEFAULT_UN_CHECK_COLOR, PERCENTAGE_SHARE_THRESHOLD } from "../../consts";
import { calculateChangeFromLastMonth, formatVisits } from "../helpers";

import type { LobEntry } from "./types";

const COLORS = CHART_COLORS.compareMainColors;

export const createLegendItem = (id: string, name: string, data: string, idx: number, visible: boolean = true) => {
    let color = COLORS[idx % COLORS.length];

    chosenSites.forEach((site, siteInfo, siteIndex) => {
        if (site === name) {
            color = COLORS[siteIndex];
        }
    });

    return {
        id,
        name,
        visible,
        assignedColor: color,
        color: visible ? color : DEFAULT_UN_CHECK_COLOR,
        data,
    };
};

export const createLobEntry = (
    lob: string,
    visits: number,
    share: number,
    domains: string[],
    yoyChange?: { CurrentPeriodVisits?: number; ComparePeriodVisits?: number },
    lobKey?: string
): LobEntry => ({
    lob,
    visits,
    share,
    formattedVisits: formatVisits(visits),
    formattedShare: formatShare(share, 2, PERCENTAGE_SHARE_THRESHOLD),
    domains,
    isTotal: false,
    yoyChange: calculateChangeFromLastMonth({
        currentPeriodVisits: yoyChange?.CurrentPeriodVisits || 0,
        comparePeriodVisits: yoyChange?.ComparePeriodVisits || 0,
    }),
    lobKey,
});
